var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavButton = function SvgNavButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "NavButton_svg__top",
    d: "M0 0h22v1H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "NavButton_svg__middle",
    d: "M0 5h14v1H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "NavButton_svg__bottom",
    d: "M0 10h22v1H0z"
  })));
};
export default SvgNavButton;